<template>
  <!-- <v-autocomplete class="body-1" flat background-color="transparent" hide-details :items="items" readonly solo
    :multiple="header.multiple"
    v-model="value" append-icon="" browser-autocomplete :item-text="header.sourceItemText"
    :item-value="header.sourceItemValue" :loading="loading" style="margin: 0;padding: 0;">
  </v-autocomplete> -->

  <!-- <v-alert style="margin: 0px; padding: 5px;" v-if="alertType || color" :color="color" :type="alertType" :value="true">
    {{display}}
  </v-alert> -->
  <span :class="color"> {{display}}</span>
</template>

<style scoped>

</style>

<script>
  import SelectionCell from "./selectionCell.ts";
  export default SelectionCell;
</script>